import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { createSubProduct } from "../../../../common/services/product.api";
import { emptyProduct } from "../../../../types/product.types";
import { useParams } from "react-router-dom";
import AutocompleteAsyncFormik from "@/common/components/form/AutoCompleteRenderAsyncFormik";
import { getWorkAndProducts, getWorkAndProductsParam } from "@/common/services/maintenance.api";

const validationSchema = Yup.object().shape({
  productId: Yup.mixed().required("Produto obrigatório"),
});

type Props = {
  onSubmit: () => void;
};

export default function FormInsertSubProduct(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const params = useParams();

  const formik = useFormik({
    initialValues: {
      productId: "",
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (data) => {
      try {
        const result = await createSubProduct({
          ...emptyProduct(),
          productId: data.productId,
          parentId: params.productId as string,
        });

        if (!result.ok) {
          notifyError(result.message as string);
          return;
        }

        notifySuccess("Criado com sucesso");
        props.onSubmit();
      } catch (err) {
        notifyError("Erro ao criar subproduto");
      }
    },
  });

    const loadOptions = async (search: string) => {
      let data;
      if (search) {
        data = (await getWorkAndProductsParam(search)).data.filter(pr => pr.totalQuantity > 0);
      } else {
        data = (await getWorkAndProducts()).data.filter(pr => pr.totalQuantity > 0);
      }
      return data.map(budget => ({ label: budget.name, value: budget.productOrWorkId }));
    }
  

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <div className="grid grid-cols-2 gap-2">
          <AutocompleteAsyncFormik
            name="productId"
            label="Selecione a peça"
            required={true}
            loadOptions={loadOptions}
            onChange={op => formik.setFieldValue("productId", op?.value)}
          />
        </div>

        <div className="flex justify-end col-span-5">
          <ButtonWithLoader
            disabled={!formik.isValid || formik.isSubmitting}
            isLoading={formik.isSubmitting}
            onClick={formik.handleSubmit}
          >
            Enviar
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}
